import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'embryo-WishList',
  templateUrl: './WishList.component.html',
  styleUrls: ['./WishList.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class WishListComponent implements OnInit, OnChanges {

   @Input() wishListProducts : any;

   @Input() count        : number;

   @Input() currency      : string;

   @Output() removeWishListData : EventEmitter<any> = new EventEmitter();

   @Output() addAllWishlistToCart : EventEmitter<any> = new EventEmitter();

   @Output() addToCart: EventEmitter<any> = new EventEmitter();

   hiddenBadge = true;

   constructor() {
      console.log("whislist");
    }

   ngOnInit() {
      console.log("whislist");
   }

   ngOnChanges() {
      console.log("whislist");
      if(this.count && this.count != 0) {
         this.hiddenBadge = false;
      } else {
         this.hiddenBadge = true;
      }
   }

   public confirmationPopup(product:any) {
      this.removeWishListData.emit(product);
   }

   public addAllToCart() {
      this.addAllWishlistToCart.emit(this.wishListProducts);
   }

   public calculatePrice(product) {
      console.log("whislist");
      let total = null;
      total = product.discount_price*product.quantity;
      return total;
   }

   public addToCartProduct(product) {
      console.log("whislist");
      this.addToCart.emit(product);
   }

}
